const LEGACY_COOKIE_NAMES = ['resourcesSearch', 'searchHistory'];

function deleteCookie(name: string) {
  // Delete for current host and path variants.
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}

export default defineNuxtPlugin(() => {
  LEGACY_COOKIE_NAMES.forEach((name) => {
    if (document.cookie.includes(`${name}=`)) {
      deleteCookie(name);
    }
  });
});
